/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Header_Our_StrategyInputs */

const en_header_our_strategy = /** @type {(inputs: Header_Our_StrategyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our strategy`)
};

/**
* | output |
* | --- |
* | "Our strategy" |
*
* @param {Header_Our_StrategyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const header_our_strategy = /** @type {((inputs?: Header_Our_StrategyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Header_Our_StrategyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_header_our_strategy(inputs)
});